import React from 'react'
import PrivatePageSF from '../../../templates/PrivatePageSF'
import SuperUserSettingsPageUI from '../../../templates/SuperUserSettingsPageUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import './OnboardingEventConfigDetailPage.css'

const OnboardingEventConfigDetailPageUI = ({ context, eventDetails, loading, errorList, onClose }) => {
    return (
        <SuperUserSettingsPageUI context={context} className='pg_su_onboarding_events_detail'>
            <div className='g_spacer_20'></div>

            {/* Breadcrumb or Header */}
            <div className='g_flex_h g_flex_at_center g_flex_space_between header-section'>
                <h2 className='page-title'>Onboarding Event Configuration</h2>
                {/* <button className='btn btn-primary' style={{ marginLeft: '10px' }}>Add New</button> */}
            </div>

            <div className='detail-container'>
                <div className='detail-header g_flex_h g_flex_at_center g_flex_space_between'>
                    <h3>Event Details</h3>
                    <i className='icon-times close-icon' onClick={onClose}></i>
                </div>

                <div className='detail-body'>
                    {loading && <SpinnerComponentUI />}
                    {errorList && errorList.length > 0 && <GenericErrorUI error={errorList[0]} />}

                    {!loading && eventDetails && (
                        <React.Fragment>
                            {/* Event Information */}
                            <div className='section'>
                                <h4 className='section-title'>Event Information</h4>
                                <div className='row'>
                                    <DetailItem label='Event Name' value={eventDetails.eventName} />
                                    <DetailItem label='Event Code' value={eventDetails.eventCode} />
                                    <DetailItem label='Template Name (WhatsApp)' value={eventDetails.whatsappTemplateName} />
                                </div>
                                <div className='row mt-3'>
                                    <DetailItem label='Message Body Text' value={eventDetails.messageBodyText} fullWidth />
                                </div>
                            </div>

                            <div className='divider'></div>

                            {/* WhatsApp Settings */}
                            <div className='section'>
                                <h4 className='section-title'>WhatsApp Settings</h4>
                                <div className='row'>
                                    <DetailItem label='WhatsApp Frequency (Days)' value={eventDetails.whatsappFrequencyDays} />
                                    <DetailItem label='Max WhatsApp Count' value={eventDetails.maxWhatsappCount} />
                                </div>
                            </div>

                            <div className='divider'></div>

                            {/* Email Settings */}
                            <div className='section'>
                                <h4 className='section-title'>Email Settings</h4>
                                <div className='row'>
                                    <DetailItem label='Email Frequency (Days)' value={eventDetails.emailFrequencyDays} />
                                    <DetailItem label='Max Email Count' value={eventDetails.maxEmailCount} />
                                </div>
                            </div>

                            <div className='divider'></div>

                            {/* Escalation Settings */}
                            <div className='section'>
                                <h4 className='section-title'>Escalation Settings</h4>
                                <div className='row'>
                                    <DetailItem label='Escalation Required' value={eventDetails.escalationRequired ? 'Yes' : 'No'} />
                                    <DetailItem label='Escalation After Reminders' value={eventDetails.escalationAfterReminders} />
                                    <DetailItem
                                        label='Escalation Email'
                                        value={eventDetails.escalationEmail ? (
                                            <div>
                                                {eventDetails.escalationEmail.split(',').map((email, idx, arr) => (
                                                    <div key={idx} style={{ wordBreak: 'break-word' }}>
                                                        {email.trim()}{idx < arr.length - 1 ? ',' : ''}
                                                    </div>
                                                ))}
                                            </div>
                                        ) : '-'}
                                    />
                                </div>
                            </div>

                            <div className='divider'></div>

                            {/* Other Settings */}
                            <div className='section'>
                                <h4 className='section-title'>Other Settings</h4>
                                <div className='row'>
                                    <DetailItem label='Cool Off Period (Min)' value={eventDetails.coolOffPeriodMin} />
                                    <DetailItem label='Is Active' value={eventDetails.isActive ? 'Yes' : 'No'} />
                                </div>
                            </div>

                        </React.Fragment>
                    )}
                </div>
            </div>
        </SuperUserSettingsPageUI>
    )
}

const DetailItem = ({ label, value, fullWidth }) => (
    <div className={`detail-item ${fullWidth ? 'col-12' : 'col-4'}`}>
        <label className='detail-label'>{label}</label>
        <div className='detail-value'>{value || '-'}</div>
    </div>
)

export default OnboardingEventConfigDetailPageUI
